import { PageBreadcrumb } from "./PageBreadcrumb";
import { PageHeading, Title } from "./Title";

type PageDetailHeaderProps = {
  title: string;
  parentLabel: string;
  parentTo: string;
  currentLabel: string;
};

export const PageDetailHeader = ({
  title,
  parentLabel,
  parentTo,
  currentLabel,
}: PageDetailHeaderProps) => {
  return (
    <PageHeading>
      <Title>{title}</Title>
      <PageBreadcrumb
        items={[
          { label: parentLabel, to: parentTo },
          { label: currentLabel },
        ]}
      />
    </PageHeading>
  );
};
